const PRO_ITEMS_COLUMNS = [
  { id: "name", label: "NAME", width: 250, fixed:'left', widget: "mediaText" },
  { id: "email", label: "EMAIL", width: 300 },
  { id: "orders", label: "ORDERS", width: 200 },
  { id: "last_active", label: "LAST ACTIVE", width: 150, widget: "number" },
  { id: "status", label: "STATUS", width: 200,  widget: "status" },
  { id: "joined", label: "JOINED", width: 200, widget: "date" }
];

const ROWS = [
  {
    name: "Ilham Budi",
    email: "ilhambudi@mail.com",
    orders: 64,
    last_active: "1 Min Ago",
    status: "Active",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Alicent Adam",
    email: "alicentadam@mail.com",
    orders: 214,
    last_active: "1 Hours Ago",
    status: "Active",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Andrew Walter",
    email: "andrewwalter@mail.com",
    orders: 421,
    last_active: "1 Day Ago",
    status: "Active",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Benjamin Strong",
    email: "benjaminstrong@mail.com",
    orders: 48,
    last_active: "14 Jan 2024 10:00",
    status: "Blocked",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Brianna Walker",
    email: "briannawalker@mail.com",
    orders: 44,
    last_active: "14 Jan 2024 10:00",
    status: "Active",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Bob White",
    email: "bobwhite@mail.com",
    orders: 140,
    last_active: "14 Jan 2024 10:00",
    status: "Active",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Camilla Chloe",
    email: "camillachloe@mail.com",
    orders: 80,
    last_active: "14 Jan 2024 10:00",
    status: "Blocked",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Fatima Azara",
    email: "fatimaazara@mail.com",
    orders: 32,
    last_active: "14 Jan 2024 10:00",
    status: "Blocked",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Brian Ortega",
    email: "brianortega@mail.com",
    orders: 32,
    last_active: "14 Jan 2024 10:00",
    status: "Active",
    joined: "05 Dec 2023 10:00"
  },
  {
    name: "Alejandro Gutierrez",
    email: "alejandrogutierrez@mail.com",
    orders: 179,
    last_active: "14 Jan 2024 10:00",
    status: "Active",
    joined: "05 Dec 2023 10:00"
  }
];

const nameObject = { PRO_ITEMS_COLUMNS, ROWS };
export default nameObject;